import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/swapElectricity/eTravelTransfer/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/swapElectricity/eTravelTransfer',
    exact: true,
    meta: {
      title: '闪送'
    }
  }
]
